export const CREATE_USER = 'CREATE_USER'
export const UPDATE_USER_ENTITY = 'UPDATE_USER_ENTITY'
export const DELETE_USER = 'DELETE_USER'